import {
  Col,
  Form,
  Row,
} from "react-bootstrap";

export default function BasicInfoEditor({
  user,
  onChange,
  showRole = false,
  roleOptions = [],
}) {
  if (!user) return null;

  return (
    <Row className="g-3">
      <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold">
            Nimi
          </Form.Label>

          <Form.Control
            value={user.nimi || ""}
            onChange={(e) =>
              onChange(
                "nimi",
                e.target.value
              )
            }
          />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold">
            Sähköposti
          </Form.Label>

          <Form.Control
            type="email"
            value={
              user.sahkoposti || ""
            }
            onChange={(e) =>
              onChange(
                "sahkoposti",
                e.target.value
              )
            }
          />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold">
            Puhelinnumero
          </Form.Label>

          <Form.Control
            value={
              user.puhelinnumero ||
              ""
            }
            onChange={(e) =>
              onChange(
                "puhelinnumero",
                e.target.value
              )
            }
          />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold">
            Ammattinimike
          </Form.Label>

          <Form.Control
            value={
              user.ammattinimike ||
              ""
            }
            onChange={(e) =>
              onChange(
                "ammattinimike",
                e.target.value
              )
            }
          />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label className="fw-semibold">
            Yritys
          </Form.Label>

          <Form.Control
            value={user.yritys || ""}
            onChange={(e) =>
              onChange(
                "yritys",
                e.target.value
              )
            }
          />
        </Form.Group>
      </Col>

      {showRole && (
        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold">
              Rooli
            </Form.Label>

            <Form.Select
              value={
                user.rooli ||
                "vieras"
              }
              onChange={(e) =>
                onChange(
                  "rooli",
                  e.target.value
                )
              }
            >
              {roleOptions.map(
                (role) => (
                  <option
                    key={role.value}
                    value={role.value}
                  >
                    {role.label}
                  </option>
                )
              )}
            </Form.Select>
          </Form.Group>
        </Col>
      )}
    </Row>
  );
}